'use client'
import { ApolloClient } from '@apollo/client'
import { monitorInit } from '@mercadoni/sinister/dist/cjs/monitors/services' // TODO: check if this is correct with new Sentry

import isSSR from '@/utils/isSSR'
import { ClientModel } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
import getSessionData from './getSessionData'
import monitorMiddleware from './monitorMiddleware'

interface MonitorProps {
  clientId: string
  ga4Id: string
  version: string
  apolloClient: ApolloClient<unknown>
  monitor: ClientModel['monitor']
}

const Monitor = ({
  clientId,
  ga4Id,
  apolloClient,
  version,
  monitor,
}: MonitorProps) => {
  if (isSSR()) {
    return null
  }
  const w = window as Window & { getCookie?: (name: string) => string }
  const sessionData = getSessionData(ga4Id)
  const sessionId = sessionData.gaSessionId || w?.getCookie?.('_IL-unique-id')
  const options = {
    clientId,
    VERSION: version,
    monitor: monitorMiddleware(monitor),
    apolloClient,
    sessionId,
  }
  monitorInit(options)

  return null
}
export default Monitor
